import React, { Component } from 'react';
import { Text, View, Platform } from 'react-native';

import NavBar from '../../navbar';
import SelectionList from './selection_list';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import OPComponent from '../components/op_component';
import { styles } from '../../constants/styles';

class SelectRelationship extends OPComponent {
  static navigatorStyle = NavBar && NavBar.navigatorStyle;

  constructor(props) {
    super(props);

    this.state = {
      items: props.caseRoles.map((role) => {
        return { label: role.name, id: role.id };
      }),
    };
  }

  handleSelect(selectedId) {
    this.props.setSelectedRole && this.props.setSelectedRole(selectedId);
  }

  render() {
    return (
      <View style={styles.containerAlt}>
        <SelectionList
          items={this.state.items}
          selectedId={this.props.selectedRoleId}
          onSelect={this.handleSelect.bind(this)}
        />
      </View>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    caseRoles: state.entities.metaData.caseRoles,
  };
}

export default connect(mapStateToProps)(SelectRelationship);
